import Cookies from 'js-cookie';

window.Cookies = Cookies;

window.Purchase = function () {
    return {
        subscription_ids: null,
        init: function () {
            let current = Cookies.getJSON('subscription_ids');
            this.subscription_ids = current && current.length ? current : [];
        },
        addAbonament: function (id) {
            if(this.subscription_ids.indexOf(id) !== -1){
                alert('Този абонамент е вече включен в заявката.');
                return;
            }
            this.subscription_ids.push(id);
            $('#subscription-'+id).hide();
            // this.subscription_ids = _.uniq(this.subscription_ids);
            this.getAbonaments();
        },
        removeAbonament: function (id) {
            if (! this.subscription_ids.length) return;
            this.subscription_ids = _.difference(this.subscription_ids, [id]);
            $('.abonament-'+id).remove();
            $('#subscription-'+id).show();
            this.getAbonaments();
        },
        getAbonaments: function (redirect_url) {
            Cookies.set('subscription_ids', this.subscription_ids);
            axios.get('/purchases/pending',  { expires: 30 })
                .then((response) => {
                   if(response.headers['x-subscription_ids']){
                       this.subscription_ids = JSON.parse(response.headers['x-subscription_ids']);
                   }
                    $('.abonaments-list').html(response.data);
                    this.updateCount();
                    if(redirect_url) {
                        location.href = redirect_url;
                    }
                });
        },
        updateCount: function () {
            Cookies.set('subscription_ids', this.subscription_ids, { expires: 30 });
            $('#abonaments-count').html(this.subscription_ids.length);
        },
        send: function (purchase_id, form) {
            axios.post('/purchase/send/'+purchase_id)
                .then(response => {
                    if(form){
                        try{
                            $('#'+ form).submit();
                        }
                        catch (e) {
                            alert(e.message)
                        }
                    }
                })
                .catch(error => {
                    alert(error);
                });
        }
    };
}();

$(function () {
    Purchase.init();
    Purchase.getAbonaments();
}());
